@if (form) {
  <form class="building-property-tax-assessment astral-form-stack astral-form-stack--relaxed" [formGroup]="form">
    <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
      <astral-select [control]="form.controls['propertyTaxBuildings']" [itemsSource]="buildingsSelection" [multiple]="true"></astral-select>
    </astral-layout-group>
    <div [formArrayName]="'buildingForms'" class="astral-form-stack astral-form-stack--relaxed">
      @for (grp of $any(buildingForms.controls); track trackByGroupId(i, grp); let i = $index) {
        <astral-accordion [header]="getBuildingLabel(grp.controls['buildingId'].value)" [translateHeader]="false" appearance="nested">
          <div [formGroupName]="i" class="astral-form-stack astral-form-stack--relaxed">
            <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
              <astral-input type="number" inputMode="decimal" [control]="grp.get('propertyTaxValueYear')"></astral-input>
              <astral-input type="number" inputMode="decimal" [control]="grp.get('propertyTaxSurface')"></astral-input>
              <astral-input type="number" inputMode="decimal" [control]="grp.get('propertyTaxArea')"></astral-input>
            </astral-layout-group>
            <astral-layout-group class="property-tax-sum" [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
              <astral-input type="number" inputMode="decimal" [control]="grp.get('premisesTaxableValue')"></astral-input>
              <div class="property-tax-sum__operator property-tax-sum__operator--plus">
                <astral-input type="number" inputMode="decimal" [control]="grp.get('landPremisesTaxableValue')"></astral-input>
              </div>
              <div class="property-tax-sum__operator property-tax-sum__operator--equals">
                <astral-input type="number" inputMode="decimal" [control]="grp.get('totalPremisesTaxableValue')"></astral-input>
              </div>
            </astral-layout-group>
            <astral-layout-group class="property-tax-sum" [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
              <astral-input type="number" inputMode="decimal" [control]="grp.get('dwellingsTaxableValue')"></astral-input>
              <div class="property-tax-sum__operator property-tax-sum__operator--plus">
                <astral-input type="number" inputMode="decimal" [control]="grp.get('landDwellingsTaxableValue')"></astral-input>
              </div>
              <div class="property-tax-sum__operator property-tax-sum__operator--equals">
                <astral-input type="number" inputMode="decimal" [control]="grp.get('totalDwellingsTaxableValue')"></astral-input>
              </div>
            </astral-layout-group>
            <div class="astral-form-actions">
              <astral-button variant="secondary" size="small" type="button" icon="trash" labelKey="DELETE_BTN" (click)="removeBuildingAt(i)"></astral-button>
            </div>
          </div>
        </astral-accordion>
      }
    </div>
  </form>
}
